import React from 'react';

import _map from 'lodash/map';
import { useStyletron } from 'baseui';

import RowRenderer from './RowRenderer';

interface IColumnRendererProps {
	fieldConfig: any;
	layoutProps: any;
	path: [];
	control: any;
	errors: any;
	mode: any;
	watch: any;
	setShowLoader: any;
	defaultValue: any;
	initialValues?: any;
	setValue: any;
}

const ColumnRenderer: React.FC<IColumnRendererProps> = (props) => {
	const {
		fieldConfig,
		layoutProps,
		path = [],
		control,
		errors,
		mode,
		watch,
		setValue,
		setShowLoader,
		defaultValue,
		initialValues
	} = props;
	const [css] = useStyletron();

	return (
		<div
			className={css({
				display: 'flex',
				flexDirection: 'column',
				flexWrap: 'wrap',
				flexBasis: '0 0 100%',
				gap: '10px',
				width: '100%'
			})}>
			{_map(layoutProps.getRows(), (row) => {
				return (
					<RowRenderer
						key={row.getKey()}
						fieldConfig={fieldConfig}
						layoutProps={row}
						control={control}
						errors={errors}
						setShowLoader={setShowLoader}
						defaultValue={defaultValue}
						mode={mode}
						watch={watch}
						setValue={setValue}
						path={path}
						initialValues={initialValues}
					/>
				);
			})}
		</div>
	);
};

export default ColumnRenderer;
